import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useResponsiveGridStyles } from './ResponsiveGrid.styles';

export type GridSpacing = 'default' | 'compact' | 'loose' | 'none';

export interface GridProps {
    children: React.ReactNode;
    spacing?: GridSpacing;
    className?: string;
}

export const ResponsiveGrid: React.FC<GridProps> = ({
    children,
    spacing = 'default',
    className,
}) => {
    const styles = useResponsiveGridStyles();

    const spacingClass = {
        default: undefined,
        compact: styles.compact,
        loose: styles.loose,
        none: styles.noGap,
    }[spacing];

    return (
        <div className={mergeClasses(styles.root, spacingClass, className)}>
            {children}
        </div>
    );
};
